var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"site--logo",attrs:{"src":_vm.mini ? _vm.configuration.brand_mini_logo_url : _vm.configuration.brand_logo_url,"alt":"logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }